//import React from "react";
import { jwtDecode } from 'jwt-decode';
import { Navigate, Outlet } from 'react-router-dom';
/*
const PrivateRoute = ({ isAuthenticated }) => {
  const token = localStorage.getItem("token");

  // تحقق من وجود توكن في localStorage
  const isTokenValid = token !== null;

  return isAuthenticated && isTokenValid ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};*/

const PrivateRoute = ({ isAuthenticated }) => {
  const token = localStorage.getItem('token');

  let isTokenValid = false;
  if (token) {
    try {
      const decoded = jwtDecode(token);
      // exp بوحدة الثواني، Date.now() بوحدة المللي ثانية
      if (decoded.exp * 1000 > Date.now()) {
        isTokenValid = true;
      } else {
        // انتهت الصلاحية، سجل خروج المستخدم
        localStorage.clear();
      }
    } catch (e) {
      // التوكن غير صالح (غير قابل للفك) => سجل خروج
      localStorage.clear();
    }
  }

  return isAuthenticated && isTokenValid ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
